//Live
export const BASE_URL_LIVE = "https://fivestar-admin-api.ondemandcreations.com";
export const API_URL_LIVE = "https://fivestar-admin-api.ondemandcreations.com";
export const MOBILE_URL_LIVE = "https://fivestar-api.ondemandcreations.com";
export const FRONTEND_URL_LIVE = "https://quote.fivestaruniverse.net";
export const STRIPE_PK_LIVE =
  "pk_live_51HS8msH26k5U2p4k92082LEyqJOThXWR42cn4ltoWI4Edi1DZiqxTMWJYjKvMs7KpG6xoOKFskc01ShJQGFAmFUd003MC2wy1I";

// Stagging
export const BASE_URL_STAGGING =
  "https://fivestarstagging-apiad.ondemandcreations.com";
export const API_URL_STAGGING =
  "https://fivestarstagging-apiad.ondemandcreations.com";
export const MOBILE_URL_STAGGING =
  "https://fivestarstagging-api.ondemandcreations.com";
export const FRONTEND_URL_STAGGING =
  "https://quote-staging.fivestaruniverse.net";
export const STRIPE_PK_STAGGING =
  "pk_test_51HS8msH26k5U2p4klTxaoGdgRA2McEnfvPkmESCnR2keD6kMocj6dHORPMzhbOWGBwXJkuQ5OwWZuV0V7EY2OW8400189R8HlA";

export const BASE_URL =
  process.env.REACT_APP_MODE === "live" ? BASE_URL_LIVE : BASE_URL_STAGGING;
export const API_URL =
  process.env.REACT_APP_MODE === "live" ? API_URL_LIVE : API_URL_STAGGING;
export const MOBILE_URL =
  process.env.REACT_APP_MODE === "live" ? MOBILE_URL_LIVE : MOBILE_URL_STAGGING;
export const FRONTEND_URL =
  process.env.REACT_APP_MODE === "live"
    ? FRONTEND_URL_LIVE
    : FRONTEND_URL_STAGGING;
export const STRIPE_PK =
  process.env.REACT_APP_MODE === "live" ? STRIPE_PK_LIVE : STRIPE_PK_STAGGING;

export const API_VERSION = "/api/v1";
export const GET_WEBSITE_TEMPLATE_DATE = "/cms/getAllCms";
export const SEND_QUERY_DATA = "/cms/sendContactEmail";
export const GET_DUMPSTER_SIZES = "/dumpster/dumpsize";
export const GET_DUMPSTER_MATERIALS = "/dumpster/dumpmaterial";
export const CHECK_ZIPCODE = "/location/checklocationwithzipcode";
export const GET_ORDER_DETAILS = "/dumpster/getCustomerPaymentDetail/";
export const ORDER_PAYMENT = "/dumpster/orderPayment";
export const GET_AGENTS = "/agent/getAgent";

export const dropon = [{ Public: "Public" }, { Private: "Private" }];
export const dropAccess = [{ Easy: "Easy" }, { Difficult: "Difficult" }];

export const dumpDuration = [
  { "A couple of days": "A couple of days" },
  { "A Week": "A Week" },
  { "A Month": "A Month" },
  { More: "More" },
];

export const hearUs = [
  { Google: "Google" },
  { Bing: "Bing" },
  { Yahoo: "Yahoo" },
  { Yelp: "Yelp" },
  { Yp: "Yp" },
  { "Our Truck": "Our Truck" },
  { Reffered: "Reffered" },
];

export const bestWay = [
  { "Please Call ASAP": "Please Call ASAP" },
  { "Please Call me in the Morning": "Please Call me in the Morning" },
  { "Please Call me in the Afternoon": "Please Call me in the Afternoon" },
  { "Please Call me in the Evening": "Please Call me in the Evening" },
  { "Please Email me in the quote": "Please Email me in the quote" },
];
